import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  // tslint:disable-next-line:pipe-naming
  name: 'removeValueQuery',
  pure: false
}) export class RemoveValueQueryPipe implements PipeTransform {
  public transform(items: any): any {
    const data: Array<any> = JSON.parse(JSON.stringify(items));
    const returnArray: Array<any> = [];
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key];
        if (element.code) {
          for (const keyFieldsQ in element.fields_query) {
            if (Object.prototype.hasOwnProperty.call(element.fields_query, keyFieldsQ)) {
              const elementFieldsQ = element.fields_query[keyFieldsQ];
              for (const keyField in element.fields) {
                if (Object.prototype.hasOwnProperty.call(element.fields, keyField)) {
                  const elementFields = element.fields[keyField];
                  if (elementFieldsQ.field_id === elementFields.field_id) {
                    returnArray.push(elementFields);
                  }
                }
              }

            }
          }
        }
      }
    }
    return returnArray;
  }
}
